import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';

@Component({
  selector: 'app-footer-funnels-one-step',
  templateUrl: './footer-funnels-one-step.component.html',
  styleUrls: ['./footer-funnels-one-step.component.scss']
})
export class FooterFunnelsOneStepComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  
  constructor() { }

  ngOnInit(): void {
  }

}
